import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import config from '../../config/constant'
import {
  VIEW_DETAILS_COMMON_KEYS,
  VIEW_PAYMENT_DETAILS_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function PaymentDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.AMOUNT)}</label>
        <span>
          <NumberFormat
            value={option?.amount}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.MERCHANT)}</label>
        <span>{option?.merchant || '-'}</span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.SERVICE_NO)}</label>
        <span>{option?.serviceNumber || '-'}</span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.SERVICE_TYPE)}</label>
        <span>{option?.serviceId || '-'}</span>
      </Col>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label> {t(VIEW_PAYMENT_DETAILS_KEYS.SOURCE_ACCOUNT_NO)}</label>
        <span>{option?.srcAcc || '-'}</span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.SOURCE_BRANCH)}</label>
        <span>{option?.srcBranch || '-'}</span>
        <label>{t(VIEW_PAYMENT_DETAILS_KEYS.SOURCE_CURRENCY)}</label>
        <span>{option?.srcCurrency || '-'}</span>
        {/* <label>{config?.SERVICE_LABELS[option?.merchant]}</label>
        <span>{option?.userMobileNum || '-'}</span> */}

        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
